import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IFilterFormValues, filterFormValues } from "./initialState";

const filterFormValuesSlice = createSlice({
  name: "filterFormValues",
  initialState: () => {
    const initialState = { ...filterFormValues };
    return initialState;
  },
  reducers: {
    updateFormValues: (state, action: PayloadAction<IFilterFormValues>) => {
      return { ...state, ...action.payload };
    },
    resetAllFormValues: (state) => {
      const preservedKeys: (keyof IFilterFormValues)[] = ['currentState', 'sort_by_profile_ranking_score',"onlyTop"];
      const newState = { ...filterFormValues } as IFilterFormValues;
    
      preservedKeys.forEach((key) => {
        (newState[key] as unknown) = (state as IFilterFormValues)[key];
      });
    
      return newState;
    },
    
    
    
    resetFormValue: (state, action) => {
      const key = action.payload;
      const initialState: any = { ...filterFormValues };
      return { ...state, [key]: initialState[key] };
    }
  },
});

export const { updateFormValues, resetAllFormValues, resetFormValue } = filterFormValuesSlice.actions;

export default filterFormValuesSlice;
